// Mock data for Visual Creationz website

export const sampleVideos = [
  {
    id: 0,
    title: "Visual Creationz - What We Do",
    category: "special",
    thumbnail: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=800&h=600&fit=crop",
    videoUrl: "https://customer-assets.emergentagent.com/job_slideshow-studio-5/artifacts/sntwamk0_Official%20VC%20AD.mp4",
    description: "Discover Visual Creationz - your partner in creating beautiful, professional visual experiences for life's most important moments",
    featured: true
  },
  {
    id: 100,
    title: "The Lake at Barston",
    subtitle: "Bespoke Wedding Presentation",
    category: "wedding",
    thumbnail: "/samples/lake-at-barston/thumbnail.jpg",
    videoUrl: "https://customer-assets-wrfwihn1.emergentagent.net/job_slideshow-studio-5/artifacts/hcvvvm8q_The%20Lake%20At%20Barston.mp4",
    description: "Bringing together photographs, music and cinematic transitions, this bespoke presentation was created for The Lake at Barston to showcase how memories can be transformed into a powerful visual experience.",
    stills: [
      "/samples/lake-at-barston/venue-aerial.jpg",
      "/samples/lake-at-barston/couple-portrait.jpg",
      "/samples/lake-at-barston/bridal-bouquet.jpg",
      "/samples/lake-at-barston/title-bokeh.jpg"
    ],
    featured: true
  },
  {
    id: 101,
    title: "Paige's Buttercream Boutique",
    subtitle: "Bespoke Promotional Presentation",
    category: "business",
    thumbnail: "/samples/paiges-buttercream/thumbnail.jpg",
    videoUrl: "https://customer-assets-wrfwihn1.emergentagent.net/job_slideshow-studio-5/artifacts/0dab9aa4b8d82ecf_Paige%27s%20Buttercream%20Cakes%20compressed.mp4",
    mobileVideoUrl: "/videos/paiges-buttercream-mobile.mp4",
    description: "A bespoke promotional presentation created by Visual Creationz, showcasing Paige's beautiful celebration cakes, cupcakes, wedding cakes and personalised creations.",
    credit: "Created by Visual Creationz.",
    featured: true
  },
  {
    id: 12,
    title: "Father's Day Tribute - A Gift for Dad",
    category: "special",
    thumbnail: "https://images.unsplash.com/photo-1581244277943-fe4a9c777189?w=800&h=600&fit=crop",
    videoUrl: "https://customer-assets.emergentagent.com/job_slideshow-studio-5/artifacts/svsec8eu_fathers%20day%20vc%20ad.mp4",
    description: "A heartfelt Father's Day cinematic tribute - the perfect way to celebrate Dad with a beautifully crafted film of memories made together",
    featured: true
  },
  {
    id: 1,
    title: "Wedding Celebration",
    category: "wedding",
    thumbnail: "https://images.unsplash.com/photo-1519741497674-611481863552?w=800&h=600&fit=crop",
    videoUrl: "https://customer-assets.emergentagent.com/job_slideshow-studio-5/artifacts/t5y13dgt_Wedding%20Slideshow%20Sample.mp4",
    description: "A beautifully crafted wedding visual experience showcasing the joy and emotion of the special day"
  },
  {
    id: 10,
    title: "Wedding Reception Celebration - An Unforgettable Evening",
    category: "wedding",
    thumbnail: "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=800&h=600&fit=crop",
    videoUrl: "https://customer-assets.emergentagent.com/job_slideshow-studio-5/artifacts/rrhq93ty_Wedding%20Reception.mp4",
    description: "A beautifully crafted visual journey through an enchanting wedding reception, capturing the romance, elegance, and pure joy of two hearts united in celebration",
    featured: true
  },
  {
    id: 2,
    title: "Memorial Tribute - A Life Remembered",
    category: "memorial",
    thumbnail: "https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=800&h=600&fit=crop",
    videoUrl: "https://customer-assets.emergentagent.com/job_slideshow-studio-5/artifacts/rklhz8zt_Funeral%20Slideshow%20Sample.mp4",
    description: "A respectful and heartfelt memorial tribute honoring a beautiful life well lived"
  },
  {
    id: 3,
    title: "100th Birthday Celebration - Century of Memories",
    category: "birthday",
    thumbnail: "https://images.unsplash.com/photo-1464207687429-7505649dae38?w=800&h=600&fit=crop",
    videoUrl: "https://customer-assets.emergentagent.com/job_slideshow-studio-5/artifacts/s8iypx6a_happy_100th_birthday%20%281080p%29.mp4",
    description: "A remarkable celebration of 100 years of life, memories, and legacy - showcasing milestone birthday expertise"
  },
  {
    id: 4,
    title: "40th Surprise Birthday Celebration",
    category: "birthday",
    thumbnail: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&h=600&fit=crop",
    videoUrl: "https://customer-assets.emergentagent.com/job_slideshow-studio-5/artifacts/fgmlgik7_40th%20Surprise%20Birthday.mp4",
    description: "A vibrant celebration capturing 40 years of joy, laughter, and unforgettable memories"
  },
  {
    id: 5,
    title: "Mother's Day Tribute - Celebrating Mom",
    category: "special",
    thumbnail: "https://images.unsplash.com/photo-1502635385003-ee1e6a1a742d?w=800&h=600&fit=crop",
    videoUrl: "https://customer-assets.emergentagent.com/job_slideshow-studio-5/artifacts/voxndjh2_Mothers%20Day%20Sample.mp4",
    description: "A heartwarming celebration of motherhood and cherished family moments"
  },
  {
    id: 6,
    title: "Romantic Gift - Love Story Visual Experience",
    category: "special",
    thumbnail: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=800&h=600&fit=crop",
    videoUrl: "https://customer-assets.emergentagent.com/job_slideshow-studio-5/artifacts/4ao1a89j_Staceys%20Slideshow.mp4",
    description: "A heartfelt gift showcasing special memories - perfect for anniversaries, proposals, and romantic occasions"
  },
  {
    id: 7,
    title: "Sweet Little Moments - Company Advert",
    category: "special",
    thumbnail: "https://images.unsplash.com/photo-1514517521153-1be72277b32f?w=800&h=600&fit=crop",
    videoUrl: "https://customer-assets.emergentagent.com/job_slideshow-studio-5/artifacts/ea29spdy_Sweet%20Little%20Moments%20Advert.mp4",
    description: "Professional commercial advert showcasing our corporate video production and brand storytelling expertise"
  },
  {
    id: 8,
    title: "Valentine's Day Love Story",
    category: "special",
    thumbnail: "https://images.unsplash.com/photo-1518199266791-5375a83190b7?w=800&h=600&fit=crop",
    videoUrl: "https://customer-assets.emergentagent.com/job_slideshow-studio-5/artifacts/ehif9itd_Valentines%20Day%20Sample.mp4",
    description: "A romantic celebration of love with beautiful moments captured in timeless style"
  },
  {
    id: 9,
    title: "Mardi Pearl Catering - Commercial Advert",
    category: "corporate",
    thumbnail: "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=800&h=600&fit=crop",
    videoUrl: "https://customer-assets.emergentagent.com/job_slideshow-studio-5/artifacts/br3mjr1c_Mardi%20Pearl.mp4",
    description: "Professional food catering company promotional video showcasing culinary excellence and event services"
  }
];

export const services = [
  {
    id: 1,
    title: "Wedding Cinematic Films",
    description: "Relive every magical moment of your day in a beautifully crafted cinematic film - the emotion, the detail, the people you love, woven into one timeless story you'll treasure forever.",
    icon: "Sparkles",
    features: [
      "Signature romantic edit style",
      "Bespoke cinematic scoring",
      "Hand-curated ceremony highlights",
      "Reception story arc",
      "Delivered in 4K premium quality"
    ],
    turnaround: "5-7 days"
  },
  {
    id: 2,
    title: "Memorial Tribute Films",
    description: "A heartfelt, dignified tribute film that honours a beautiful life - crafted with sensitivity, warmth, and quiet cinematic care.",
    icon: "Heart",
    features: [
      "Restored & enhanced photographs",
      "Carefully chosen, emotive soundtrack",
      "Gentle, respectful transitions",
      "Personalised dedications & dates",
      "Cinema-grade 4K finish"
    ],
    turnaround: "3-5 days"
  },
  {
    id: 3,
    title: "Birthday Celebration Films",
    description: "Celebrate the milestones - every laugh, every era, every chapter - woven into a vibrant cinematic film that captures a lifetime in motion.",
    icon: "PartyPopper",
    features: [
      "Chronological story-driven edit",
      "Upbeat, era-matched soundtrack",
      "Tailored motion design & effects",
      "Personalised birthday messages",
      "Share-ready cinematic delivery"
    ],
    turnaround: "3-5 days"
  },
  {
    id: 4,
    title: "Bespoke Cinematic Projects",
    description: "Something one-of-a-kind in mind? We craft fully bespoke cinematic films for any occasion, brand or vision - your story, told beautifully.",
    icon: "Film",
    features: [
      "Fully bespoke creative direction",
      "Any occasion, theme or brief",
      "Corporate & brand storytelling",
      "Reunions, anniversaries & legacies",
      "Premium business presentations"
    ],
    turnaround: "Varies"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Thompson",
    occasion: "Mother's Memorial",
    rating: 5,
    text: "The memorial tribute created for my mother was absolutely perfect. It captured her spirit beautifully and brought comfort to our entire family. Thank you for your sensitivity and professionalism.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop"
  },
  {
    id: 2,
    name: "Michael & Emma Davis",
    occasion: "Wedding",
    rating: 5,
    text: "Our wedding visual experience exceeded all expectations! It's like reliving our special day every time we watch it. The music, transitions, and quality are exceptional. Highly recommend!",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop"
  },
  {
    id: 3,
    name: "David Roberts",
    occasion: "Dad's 70th Birthday",
    rating: 5,
    text: "What an amazing surprise for my dad's 70th! The visual experience had everyone in tears of joy. Seven decades of memories beautifully presented. Worth every penny!",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop"
  }
];

export const howItWorksSteps = [
  {
    step: 1,
    title: "Choose Your Package & Pay Deposit",
    description: "Choose the collection that suits your occasion - Essential Collection (£100), Signature Collection (£150) or Cinematic Collection (£200). A small booking deposit secures your project date; deposits are £20, £30 or £50 depending on the package selected. The remaining balance, including any add-ons, is due before your finished cinematic presentation is delivered.",
    icon: "Upload"
  },
  {
    step: 2,
    title: "Share Your Media",
    description: "After placing your order, you'll receive a unique QR code to scan with your phone for instant uploads! Alternatively, upload your photos and videos through our secure form or send them via email. We accept all common formats to make the process easy.",
    icon: "Settings"
  },
  {
    step: 3,
    title: "We Create Your Masterpiece",
    description: "Your film is professionally edited with carefully selected music, transitions and effects. We'll keep you updated throughout the process to ensure your project is created with care and attention to detail.",
    icon: "Video"
  },
  {
    step: 4,
    title: "Receive Your Video",
    description: "Review your completed cinematic presentation and request any revisions included in your package. Once you're completely happy, we'll deliver your finished 4K masterpiece via a secure private Google Drive download link, and every order also includes a physical USB copy for safekeeping. Your Google Drive download preserves the original quality, allowing you to easily download, save and enjoy your presentation on your preferred device.",
    icon: "Download"
  }
];

export const pricingInfo = {
  upTo30: {
    pricePerPhoto: 4,
    currency: "£",
    label: "Up to 30 Photos"
  },
  over30: {
    pricePerPhoto: 3,
    currency: "£",
    label: "Over 30 Photos"
  },
  included: [
    "Cinematic 4K visual storytelling production",
    "Beautifully edited & polished photos",
    "Music of your choice",
    "Delivered via secure private Google Drive download + physical USB (both included)",
    "Perfect for sharing with family, friends, colleagues or businesses"
  ],
  perfectFor: [
    "Weddings",
    "Special Occasions",
    "Celebrations",
    "Memorials",
    "Business Presentations"
  ]
};

export const contactInfo = {
  phone: "07494 164379",
  email: "VisualCreationz@hotmail.com",
  facebook: "facebook.com/visualcreationz",
  tiktok: "www.tiktok.com/@visual.creationz",
  whatsapp: "07494164379"
};
